import { NgModule } from '@angular/core';
import { FilterComdataPipe } from './filtercompanydata.pipe';

@NgModule({
  declarations: [FilterComdataPipe],
  imports: [],
  exports:[FilterComdataPipe]
})
export class FilterCompanyDataModule { }
